import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  cultivationUpdate: {
    status: "idle",
    success: false,
  },
}

export const updateData = createAsyncThunk('update', async (data) => {
    const {token, model, crop, selectedTask, selectedDPLD, selectedDaily} = data
    let dpld = selectedDPLD
    if (selectedDaily === true) {
        dpld = -1
    }
    let payload = JSON.stringify({
        Name: model,
        Crop: crop,
        Action: selectedTask,
        DayFromPLD: new Number(dpld),
    })
    const axios = require("axios")
    const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/data/cultivation/YILI/add` 

      const response = await axios.post(url,
                 payload,
                 { headers })
      return response.data
})

const cultivationUpdateSlice = createSlice({
  name: 'update',
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [updateData.pending.type]:(state, action) => {
      state.cultivationUpdate = {
        status: "loading",
        success: false,
      }
    },
    [updateData.fulfilled.type]:(state, action) => {
      state.cultivationUpdate = {
        status: "idle",
        success: action.payload.success,
      }
    },
    [updateData.rejected.type]:(state, action) => {
      state.cultivationUpdate = {
        status: "idle",
        success: false,
      }
    },
  }
})

export default cultivationUpdateSlice.reducer
